import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Profile from '@pages/profile/Profile';

const ProfileRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`}>
                <Profile />
            </Route>
            <Route exact path={`${path}/:action`}>
                <Profile />
            </Route>
        </Switch>
    );
};

export default ProfileRoutes;
